import React from "react";
import styled from "styled-components";
import Milestone from "../../../components/Milestone";
import {
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalSubtitle,
    ModalButtonGroup,
    ModalPrimaryButton,
    ModalSecondaryButton,
} from "../../../components/Modal";

const SmallPaddedElement = styled.div`
    margin: 1.5rem 0 0 0;
`;

const QUEUE_THRESHOLD = 2;

export function handleOrderPickupTime(pickupTime: any, totalPreparationTime: any) {
    const now = new Date().getTime();
    const diff = pickupTime - now;
    let hasOrdersInQueue = false, orderPickupTime = "";
    // First milestone: floor minutes, clamp to at least 1.
    let diffInMinutes: any = Math.floor(diff / (60 * 1000));
    if (diffInMinutes > QUEUE_THRESHOLD) {
        hasOrdersInQueue = true;
        diffInMinutes = Math.max(1, diffInMinutes);
        orderPickupTime = `${diffInMinutes} ${diffInMinutes === 1 ? "Min" : "Mins"}`;
    } else {
        orderPickupTime = "Now"
    }

    // First milestone timestamp: show exact scheduled time (may differ by seconds).
    let orderPickupTimestamp: any = new Date(pickupTime).toLocaleTimeString("en-us", { minute: "2-digit", hour: "2-digit" });
    orderPickupTimestamp = `(${orderPickupTimestamp})`;

    const diffLastDishEstimatedReadyTime = pickupTime + totalPreparationTime - now;
    // Second milestone: ceil to the next full minute.
    let diffInMinutesLastDishEstimatedReadyTime: any = Math.ceil(diffLastDishEstimatedReadyTime / (60 * 1000));
    diffInMinutesLastDishEstimatedReadyTime = Math.max(1, diffInMinutesLastDishEstimatedReadyTime);

    const lastDishReadyTime =
        diffInMinutesLastDishEstimatedReadyTime + (diffInMinutesLastDishEstimatedReadyTime == 1 ? " Min" : " Mins");
    // Align timestamp with ceiled minutes to avoid a 1-minute mismatch.
    const baseMinute = Math.floor(now / (60 * 1000)) * (60 * 1000);
    const alignedLastDishReadyMs = baseMinute + diffInMinutesLastDishEstimatedReadyTime * (60 * 1000);
    let lastDishReadyTimestamp: any = new Date(alignedLastDishReadyMs).toLocaleTimeString("en-us", { minute: "2-digit", hour: "2-digit" });
    lastDishReadyTimestamp = `(${lastDishReadyTimestamp})`;

    return {
        orderPickupTime,
        lastDishReadyTime,
        hasOrdersInQueue,
        orderPickupTimestamp,
        lastDishReadyTimestamp,
    };
}

type OrderPickupTimeModalProps = {
    isOpen: boolean;
    data: any;
    onCancel: () => void;
    onConfirm: () => void;
    primaryButtonLoading: boolean;
};

export const OrderPickupTimeModal: React.FC<OrderPickupTimeModalProps> = ({ isOpen, data, onCancel, onConfirm, primaryButtonLoading }) => {
    if (!isOpen) return null;
    return (
        <ModalOverlay>
            <Modal>
                <ModalHeader>Order Time Estimates</ModalHeader>
                {data?.hasOrdersInQueue ? <ModalSubtitle>Xook is wrapping up previous orders.</ModalSubtitle> : ""}
                <SmallPaddedElement>
                    <Milestone
                        milestones={[
                            { marker: "Your first dish starts in", title: data?.orderPickupTime, subtitle: data?.orderPickupTimestamp },
                            { marker: "And last dish will be out in", title: data?.lastDishReadyTime, subtitle: data?.lastDishReadyTimestamp },
                        ]}
                    />
                </SmallPaddedElement>
                <ModalSubtitle>Note: Times may vary slightly. We will keep your notified via sms regarding your dish status.</ModalSubtitle>
                <ModalButtonGroup alignItems="space-between">
                    <ModalSecondaryButton disabled={primaryButtonLoading} onClick={onCancel}>
                        Cancel
                    </ModalSecondaryButton>
                    <ModalPrimaryButton loading={primaryButtonLoading} onClick={onConfirm}>
                        OKAY
                    </ModalPrimaryButton>
                </ModalButtonGroup>
            </Modal>
        </ModalOverlay>
    );
};

export default OrderPickupTimeModal;


